import { cn } from '@/lib/utils';
import { memo, useMemo } from 'react';
import PointIcon from '../images/point-icon.png';
import { formatNumberWithThousands } from '@/utils';

interface PointCountProps {
  count: number;
  className?: string;
  iconClassName?: string;
  needAdjust?: boolean;
}

const PointCount = memo((props: PointCountProps) => {
  const { count, className, iconClassName, needAdjust } = props;

  const showCount = useMemo(() => {
    if (count >= 10000) {
      return `${(count / 10000).toFixed(1)}w`;
    }
    return count;
  }, [count]);

  return (
    <div
      className={cn(
        'flex items-center rounded-sm px-sm bg-base font-medium',
        needAdjust ? 'gap-sm text-[14px]' : 'gap-md',
        className,
      )}
    >
      <img src={PointIcon} alt="coin" className={cn('w-[16px] h-[16px]', iconClassName)} />
      <span title={count.toString()}>
        {needAdjust ? showCount : formatNumberWithThousands(count)}
      </span>
    </div>
  );
});

export default PointCount;
